function formatMarginRatio(marginRatioVal: number) {
    if (marginRatioVal < 0.09 && marginRatioVal > 0) {
        // if marginRatio < 9% (single digit), show x.xx%, else xx.x%
        return `${Math.round(marginRatioVal * 10000) / 100}﹪`
    } else if (marginRatioVal >= 0.09 && marginRatioVal < 10) {
        return `${Math.round(marginRatioVal * 1000) / 10}﹪`
    } else if (marginRatioVal >= 10 && marginRatioVal < 100) {
        return `${Math.round(marginRatioVal * 100)}﹪`
    } else if (marginRatioVal >= 100) {
        return "10000﹪+"
    } else {
        // empty state
        return "—"
    }
}

export { formatMarginRatio }
